<template>
  <b-container class="d-flex justify-content-center align-items-center">
    <a
      :href="target_url"
      rel="noopener noreferrer"
      class="d-flex justify-content-center"
    >
      <img
        :src="require('@/assets/Logo.png')"
        alt="Forever Living"
        style="width: 80%; height: auto"
      />
    </a>
  </b-container>
</template>

<script>
export default {
  name: "logo_display",
  props: {
    target_url: {
      type: String,
      default: "/",
    },
  },
};
</script>
